"use strict";
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/generate-deployments/README.md" for how to modify
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.asPaymentFrontendIntegration = exports.PaymentFrontendIntegration = exports.asPaymentFraudProvider = exports.PaymentFraudProvider = exports.asPaymentProvider = exports.PaymentProvider = exports.asPaymentMethod = exports.PaymentMethod = exports.asTopLevelDomain = exports.TopLevelDomain = exports.asAwsRegion = exports.AwsRegion = exports.asCurrencyCode = exports.CurrencyCode = exports.asMoneyFormatLocale = exports.MoneyFormatLocale = exports.asLanguage = exports.Language = exports.asLocale = exports.Locale = exports.asIsoCountryCode3 = exports.IsoCountryCode3 = exports.asIsoCountryCode2 = exports.IsoCountryCode2 = exports.asBrand = exports.Brand = void 0;
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-redeclare */
/* eslint-disable @typescript-eslint/no-unused-vars */
exports.Brand = {
    BK: 'BK',
    FHS: 'FHS',
    PLK: 'PLK',
    TH: 'TH',
};
const asBrand = (str) => {
    if (Object.values(exports.Brand).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asBrand = asBrand;
exports.IsoCountryCode2 = {
    AE: 'AE',
    AQ: 'AQ',
    AR: 'AR',
    AT: 'AT',
    AU: 'AU',
    BH: 'BH',
    BR: 'BR',
    CA: 'CA',
    CH: 'CH',
    CL: 'CL',
    CZ: 'CZ',
    DE: 'DE',
    EG: 'EG',
    ES: 'ES',
    FR: 'FR',
    GB: 'GB',
    IE: 'IE',
    KR: 'KR',
    KW: 'KW',
    MA: 'MA',
    MX: 'MX',
    MY: 'MY',
    NL: 'NL',
    NZ: 'NZ',
    OM: 'OM',
    PH: 'PH',
    PL: 'PL',
    PR: 'PR',
    PT: 'PT',
    QA: 'QA',
    RO: 'RO',
    SA: 'SA',
    SG: 'SG',
    TW: 'TW',
    US: 'US',
    ZA: 'ZA',
};
const asIsoCountryCode2 = (str) => {
    if (Object.values(exports.IsoCountryCode2).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asIsoCountryCode2 = asIsoCountryCode2;
exports.IsoCountryCode3 = {
    ARE: 'ARE',
    ARG: 'ARG',
    ATA: 'ATA',
    AUS: 'AUS',
    AUT: 'AUT',
    BHR: 'BHR',
    BRA: 'BRA',
    CAN: 'CAN',
    CHE: 'CHE',
    CHL: 'CHL',
    CZE: 'CZE',
    DEU: 'DEU',
    EGY: 'EGY',
    ESP: 'ESP',
    FRA: 'FRA',
    GBR: 'GBR',
    IRL: 'IRL',
    KOR: 'KOR',
    KWT: 'KWT',
    MAR: 'MAR',
    MEX: 'MEX',
    MYS: 'MYS',
    NLD: 'NLD',
    NZL: 'NZL',
    OMN: 'OMN',
    PHL: 'PHL',
    POL: 'POL',
    PRI: 'PRI',
    PRT: 'PRT',
    QAT: 'QAT',
    ROU: 'ROU',
    SAU: 'SAU',
    SGP: 'SGP',
    TWN: 'TWN',
    USA: 'USA',
    ZAF: 'ZAF',
};
const asIsoCountryCode3 = (str) => {
    if (Object.values(exports.IsoCountryCode3).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asIsoCountryCode3 = asIsoCountryCode3;
exports.Locale = {
    ar_ae: 'ar-AE',
    en_ae: 'en-AE',
    en_aq: 'en-AQ',
    es_aq: 'es-AQ',
    fr_aq: 'fr-AQ',
    de_aq: 'de-AQ',
    it_aq: 'it-AQ',
    uk_aq: 'uk-AQ',
    th_aq: 'th-AQ',
    es_ar: 'es-AR',
    de_at: 'de-AT',
    en_at: 'en-AT',
    en_au: 'en-AU',
    pt_br: 'pt-BR',
    en_ca: 'en-CA',
    fr_ca: 'fr-CA',
    en_ch: 'en-CH',
    de_ch: 'de-CH',
    fr_ch: 'fr-CH',
    it_ch: 'it-CH',
    es_cl: 'es-CL',
    en: 'en',
    cs_cz: 'cs-CZ',
    en_cz: 'en-CZ',
    de_de: 'de-DE',
    en_de: 'en-DE',
    ar_eg: 'ar-EG',
    en_eg: 'en-EG',
    es_es: 'es-ES',
    ca_es: 'ca-ES',
    gl_es: 'gl-ES',
    eu_es: 'eu-ES',
    en_es: 'en-ES',
    en_gb: 'en-GB',
    en_ie: 'en-IE',
    ar_ma: 'ar-MA',
    fr_ma: 'fr-MA',
    es_mx: 'es-MX',
    en_mx: 'en-MX',
    ms_my: 'ms-MY',
    en_my: 'en-MY',
    nl_nl: 'nl-NL',
    en_nl: 'en-NL',
    en_nz: 'en-NZ',
    ar_om: 'ar-OM',
    en_om: 'en-OM',
    tl_ph: 'tl-PH',
    en_ph: 'en-PH',
    pl_pl: 'pl-PL',
    en_pl: 'en-PL',
    en_pr: 'en-PR',
    es_pr: 'es-PR',
    pt_pt: 'pt-PT',
    en_pt: 'en-PT',
    es_pt: 'es-PT',
    ro_ro: 'ro-RO',
    en_ro: 'en-RO',
    ar_sa: 'ar-SA',
    en_sa: 'en-SA',
    en_us: 'en-US',
    en_za: 'en-ZA',
    en_sg: 'en-SG',
    ms_sg: 'ms-SG',
    ta_sg: 'ta-SG',
    zh_sg: 'zh-SG',
    ar_bh: 'ar-BH',
    en_bh: 'en-BH',
    pt_es: 'pt-ES',
    fr_fr: 'fr-FR',
    en_fr: 'en-FR',
    ko_kr: 'ko-KR',
    en_kr: 'en-KR',
    ar_kw: 'ar-KW',
    en_kw: 'en-KW',
    ar_qa: 'ar-QA',
    en_qa: 'en-QA',
    zh_tw: 'zh-TW',
    en_tw: 'en-TW',
};
const asLocale = (str) => {
    const [language, iso2] = str.replace('_', '-').split('-');
    const localeStr = (iso2
        ? `${language.toLowerCase()}-${iso2.toUpperCase()}`
        : language.toLowerCase());
    if (Object.values(exports.Locale).includes(localeStr)) {
        return localeStr;
    }
    return;
};
exports.asLocale = asLocale;
exports.Language = {
    ar: 'ar',
    ca: 'ca',
    cs: 'cs',
    de: 'de',
    en: 'en',
    es: 'es',
    eu: 'eu',
    fr: 'fr',
    gl: 'gl',
    it: 'it',
    ko: 'ko',
    ms: 'ms',
    nl: 'nl',
    pl: 'pl',
    pt: 'pt',
    ro: 'ro',
    ta: 'ta',
    th: 'th',
    tl: 'tl',
    uk: 'uk',
    zh: 'zh',
};
const asLanguage = (str) => {
    if (Object.values(exports.Language).includes(str.toLowerCase())) {
        return str.toLowerCase();
    }
    return;
};
exports.asLanguage = asLanguage;
exports.MoneyFormatLocale = {
    ar_ae: 'ar_ae',
    ar_bh: 'ar_bh',
    ar_eg: 'ar_eg',
    ar_kw: 'ar_kw',
    ar_ma: 'ar_ma',
    ar_om: 'ar_om',
    ar_qa: 'ar_qa',
    cmn: 'cmn',
    cs: 'cs',
    de: 'de',
    de_at: 'de_at',
    en_au: 'en_au',
    en_cl: 'en_cl',
    en_gb: 'en_gb',
    en_nz: 'en_nz',
    en_pr: 'en_pr',
    en_sa: 'en_sa',
    en_za: 'en_za',
    es_ar: 'es_ar',
    es_es: 'es_es',
    es_mx: 'es_mx',
    fr_ch: 'fr_ch',
    fr_fr: 'fr_fr',
    ko_kr: 'ko_kr',
    ms_my: 'ms_my',
    nl_nl: 'nl_nl',
    pl: 'pl',
    pt_br: 'pt_br',
    pt_pt: 'pt_pt',
    ro: 'ro',
    tl_ph: 'tl_ph',
    zh_tw: 'zh_tw',
};
const asMoneyFormatLocale = (str) => {
    if (Object.values(exports.MoneyFormatLocale).includes(str.toLowerCase())) {
        return str.toLowerCase();
    }
    return;
};
exports.asMoneyFormatLocale = asMoneyFormatLocale;
exports.CurrencyCode = {
    AED: 'AED',
    ARS: 'ARS',
    AUD: 'AUD',
    BHD: 'BHD',
    BRL: 'BRL',
    CAD: 'CAD',
    CHF: 'CHF',
    CLP: 'CLP',
    CZK: 'CZK',
    EGP: 'EGP',
    EUR: 'EUR',
    GBP: 'GBP',
    KRW: 'KRW',
    KWD: 'KWD',
    MAD: 'MAD',
    MXN: 'MXN',
    MYR: 'MYR',
    NZD: 'NZD',
    OMR: 'OMR',
    PHP: 'PHP',
    PLN: 'PLN',
    QAR: 'QAR',
    RON: 'RON',
    SAR: 'SAR',
    SGD: 'SGD',
    TWD: 'TWD',
    USD: 'USD',
    ZAR: 'ZAR',
};
const asCurrencyCode = (str) => {
    if (Object.values(exports.CurrencyCode).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asCurrencyCode = asCurrencyCode;
exports.AwsRegion = {
    EU_CENTRAL_1: 'eu-central-1',
    EU_WEST_3: 'eu-west-3',
    US_EAST_2: 'us-east-2',
    AP_SOUTHEAST_1: 'ap-southeast-1',
    US_EAST_1: 'us-east-1',
};
const asAwsRegion = (str) => {
    if (Object.values(exports.AwsRegion).includes(str.toLowerCase())) {
        return str.toLowerCase();
    }
    return;
};
exports.asAwsRegion = asAwsRegion;
exports.TopLevelDomain = {
    ae: 'ae',
    io: 'io',
    ar: 'ar',
    at: 'at',
    com_au: 'com.au',
    br: 'br',
    ca: 'ca',
    ch: 'ch',
    cl: 'cl',
    cz: 'cz',
    de: 'de',
    com_eg: 'com.eg',
    es: 'es',
    co_uk: 'co.uk',
    ie: 'ie',
    ma: 'ma',
    com_mx: 'com.mx',
    com_my: 'com.my',
    nl: 'nl',
    co_nz: 'co.nz',
    co_om: 'co.om',
    ph: 'ph',
    pl: 'pl',
    pr: 'pr',
    pt: 'pt',
    ro: 'ro',
    com_sa: 'com.sa',
    com: 'com',
    co_za: 'co.za',
    com_sg: 'com.sg',
    bh: 'bh',
    fr: 'fr',
    co_kr: 'co.kr',
    com_kw: 'com.kw',
    qa: 'qa',
    tw: 'tw',
    aq: 'aq',
};
const asTopLevelDomain = (str) => {
    if (Object.values(exports.TopLevelDomain).includes(str.toLowerCase())) {
        return str.toLowerCase();
    }
    return;
};
exports.asTopLevelDomain = asTopLevelDomain;
exports.PaymentMethod = {
    APPLEPAY: 'APPLEPAY',
    GOOGLEPAY: 'GOOGLEPAY',
    PREPAID: 'PREPAID',
    SCHEME: 'SCHEME',
};
const asPaymentMethod = (str) => {
    if (Object.values(exports.PaymentMethod).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asPaymentMethod = asPaymentMethod;
exports.PaymentProvider = {
    ADYEN: 'ADYEN',
    CHASE: 'CHASE',
    CHASETHDIGITAL: 'CHASETHDIGITAL',
    FIRSTDATA: 'FIRSTDATA',
    FIRSTPAY: 'FIRSTPAY',
    PAYMARK: 'PAYMARK',
    VRPAYMENT: 'VRPAYMENT',
};
const asPaymentProvider = (str) => {
    if (Object.values(exports.PaymentProvider).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asPaymentProvider = asPaymentProvider;
exports.PaymentFraudProvider = {
    FORTER: 'FORTER',
};
const asPaymentFraudProvider = (str) => {
    if (Object.values(exports.PaymentFraudProvider).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asPaymentFraudProvider = asPaymentFraudProvider;
exports.PaymentFrontendIntegration = {
    ADYEN: 'ADYEN',
    CHASETHDIGITAL: 'CHASETHDIGITAL',
    FIRSTDATA: 'FIRSTDATA',
    VRPAYMENT: 'VRPAYMENT',
};
const asPaymentFrontendIntegration = (str) => {
    if (Object.values(exports.PaymentFrontendIntegration).includes(str.toUpperCase())) {
        return str.toUpperCase();
    }
    return;
};
exports.asPaymentFrontendIntegration = asPaymentFrontendIntegration;
